import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { Button } from 'reactstrap';

import { revealKey } from 'Redux/ducks/orders';
import drmToString from 'Helpers/Product/DrmToString';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';

const messages = defineMessages({
  error: {
    id: 'vaultn-activate.error',
    defaultMessage: 'There was a problem activating your game, please try again or contact support',
  },
});

const VaultnActivate = ({ game, orderStatus, oid, bid, emailConfirmed }) => {
  const [revealing, setRevealing] = useState(false);
  const intl = useIntl();
  const $element = useRef(null);

  useEffect(() => {
    // Detect matching keylessIid from url and scroll to this item
    if (getUrlParameter('keylessReturn') && getUrlParameter('keylessIid') === game.iid && $element.current) {
      window.scrollTo({
        behavior: 'smooth',
        top:
          $element.current.getBoundingClientRect().top - 100,
      });
    }
    if (getUrlParameter('keylessReturn') && getUrlParameter('keylessIid') === game.iid && getUrlParameter('errorMessage')) {
      setTimeout(() => {
        window.alert(`${intl.formatMessage(messages.error)}\n${getUrlParameter('errorMessage')}`); // eslint-disable-line no-alert
      }, 500);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const reveal = async () => {
    const { key } = await revealKey(oid, bid, game);

    if (key === 'error') {
      window.alert(intl.formatMessage(messages.error)); // eslint-disable-line no-alert
      setRevealing(false);
      return false;
    }

    window.location.href = key;
    return false;
  };

  const drmString = drmToString(game).toUpperCase();

  if (!emailConfirmed) {
    return (
      <div className="btn btn-secondary btn-block disabled">
        <FormattedMessage id="vaultn-activate.verify-email" defaultMessage="Please verify your email address to redeem" />
      </div>
    );
  }

  if (orderStatus !== 'COMPLETE') {
    return false;
  }

  if (game.status === 'revealed') {
    return (
      <div className="key-activated-externally" ref={$element}>
        <FormattedMessage
          id="vaultn-activate.activated-vaultn"
          defaultMessage="Activated on {platformName} - User: {username}"
          values={{
            platformName: drmString,
            username: game.vaultnRedeemedUser,
          }}
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="w-100" ref={$element}>
        <Button
          block
          color="primary"
          onClick={() => {
            setRevealing(true);
            reveal();
          }}
        >
          {!revealing &&
            <FormattedMessage id="vaultn-reveal.activate" defaultMessage="Activate on {platformName}" values={{ platformName: drmString }} tagName="span" />
          }
          {revealing &&
            <div className="w-100">
              <FontAwesomeIcon spin icon={faSpinner} className="mr-2" />
              <b>
                <FormattedMessage id="vaultn-reveal.activating" defaultMessage="Activating" />
              </b>
            </div>
          }
        </Button>
      </div>
    </React.Fragment>
  );
};

VaultnActivate.propTypes = {
  game: PropTypes.shape({}).isRequired,
  orderStatus: PropTypes.string.isRequired,
  oid: PropTypes.string.isRequired,
  emailConfirmed: PropTypes.bool.isRequired,
  bid: PropTypes.string,
};


export default VaultnActivate;
